export const homebotHostname = process.env.REACT_APP_HB_HOSTNAME
export const mikasaBaseUrl = process.env.REACT_APP_MIKASA_BASE_URL
export const clientFrontendUri = process.env.REACT_APP_CFE_BASE_URL
export const showDevTools = process.env.REACT_APP_SHOW_DEV_TOOLS

export const gaMeasurementId = process.env.REACT_APP_GA_MEASUREMENT_ID
export const gaApiSecret = process.env.REACT_APP_GA_API_SECRET

export const widgetMode = process.env.WIDGET_MODE
export const nodeEnv = process.env.NODE_ENV
